// Copyright 2021 Rennie Glen Software LLC
export enum Units {
    POINTS = "points",
    INCHES = "inches",
    MMS = "mms"
}

export interface UnitsBox {
    readonly units: Units;
    setUnits(units: Units): void;
}

export function convert<T extends number | number[]>(scalar: T, fromUnits: Units, toUnits: Units): T {
    if (fromUnits == toUnits) {
        return scalar;
    }
    if (Array.isArray(scalar)) {
        return scalar.map(scalar => convertNumber(scalar, fromUnits, toUnits)) as T;
    }
    return convertNumber(scalar, fromUnits, toUnits) as T;
}

function convertNumber(n: number, fromUnits: Units, toUnits: Units): number {
    const join = (a: Units, b: Units) => {
        return a + "-" + b;
    };
    switch (join(fromUnits, toUnits)) {
        case join(Units.POINTS, Units.INCHES):
            return n / 72;
        case join(Units.INCHES, Units.POINTS):
            return n * 72;
        case join(Units.INCHES, Units.MMS):
            return n * 25.4;
        case join(Units.MMS, Units.INCHES):
            return n / 25.4;
        case join(Units.POINTS, Units.MMS):
            return n * 25.4 / 72;
        case join(Units.MMS, Units.POINTS):
            return n * 72 / 25.4;
        default:
            throw "Bad units passed to convert: " + fromUnits + " " + toUnits;
    }
}